// Module
var code = "<div id=\"main\"> <router-view v-wechat-title=\"this.$route.meta.title\"/> </div> ";
// Exports
module.exports = code;